import { render } from "./table_companies.vue?vue&type=template&id=cc7db5ca&scoped=true"
import script from "./table_companies.vue?vue&type=script&lang=js"
export * from "./table_companies.vue?vue&type=script&lang=js"

import "./table_companies.vue?vue&type=style&index=0&id=cc7db5ca&scoped=true&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7db5ca"]])

export default __exports__